/**
 * @file 认证表单弹窗
 * @author
 */
// @ts-nocheck
import React, {useState, useEffect} from 'react';
import {Modal} from 'antd';
import AuthForm from './authForm';

interface Props {
    open: boolean;
    onOk: Function;
    onCancel: Function;
    source: string;
}
export default function AuthModal(props: Props) {
    const {open, onOk, onCancel} = props;
    const [autFormModalShow, setAutFormModalShow] = useState(false);
    useEffect(() => {
        setAutFormModalShow(open);
    }, [open]);
    return (
        <Modal
            title=""
            okText="提交"
            wrapClassName="attest-auth-form-modal"
            className="attest-auth-form-modal-box"
            width={470}
            centered
            open={autFormModalShow}
            closable={true}
            onOk={onOk}
            onCancel={onCancel}
            destroyOnClose={true}
            footer={null}
        >
            <div className="attest-auth-form-modal-content">
                <div className="attest-auth-form-modal-content-title">留下联系方式</div>
                <p className="attest-auth-form-modal-content-subtitle">提交信息后，官方合作伙伴将致电为您提供1V1服务，</p>
                <p className="attest-auth-form-modal-content-subtitle">协助您付费上线</p>
                <AuthForm {...props} isModalForm={true} onSubmitSuccess={onCancel}/>
            </div>
        </Modal>
    );

}
